import { ApiService } from './api.service'
import { ApmService } from './apm.service'
import { AuthService } from './auth.service'
import { BridgeService } from './bridge.service'
import { BrowserStorageService } from './browserStorage.service'
import { BrowserWindowService } from './browserWindow.service'
import { ClipboardService } from './clipboard.service'
import { MainService } from './main.service'
import { MobileOnlyStubService } from './mobile-only-stub.service'
import { NumberService } from './number.service'
import { PageScrollService } from './page-scroll.service'
import { PublicService } from './public.service'
import { RejectionService } from './rejection.service'
import { RouterService } from './router.service'
import { SchedulerService } from './scheduler.service'
import { ScrollNavigationService } from './scroll-navigation.service'
import { SourceLoaderService } from './source-loader.service'
import { WindowService } from './window.service'

export const services = (gaApp) => ({
  main: new MainService(gaApp),
  router: new RouterService(gaApp),
  api: new ApiService(gaApp),
  scrollNavigation: new ScrollNavigationService(gaApp),
  apm: new ApmService(gaApp),
  browserStorage: new BrowserStorageService(gaApp),
  browserWindow: new BrowserWindowService(gaApp),
  scheduler: new SchedulerService(gaApp),
  clipboard: new ClipboardService(gaApp),
  pageScroll: new PageScrollService(gaApp),
  number: new NumberService(gaApp),
  window: new WindowService(gaApp),
  public: new PublicService(gaApp),
  sourceLoader: new SourceLoaderService(gaApp),
  auth: new AuthService(gaApp),
  bridge: new BridgeService(gaApp),
  rejection: new RejectionService(gaApp),
  mobileOnlyStub: new MobileOnlyStubService(gaApp),
})
